<template>
  <div class="train-details-in-modal">
    <div class="details-item">
      <p class="title">培训名称</p>
      <p class="content">{{ trainData.name }}</p>
    </div>
    <div class="details-item">
      <p class="title">时间</p>
      <p class="content">
        {{ moment(trainData.startDate).format('YYYY-MM-DD') }} 至
        {{ moment(trainData.endDate).format('YYYY-MM-DD') }}
      </p>
    </div>
    <div class="details-item">
      <p class="title">地点</p>
      <p class="content">
        {{ trainData.location }}
      </p>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  props: { trainData: Object },
  data() {
    return {}
  },
  methods: { moment },
}
</script>
<style lang="less" scoped>
.train-details-in-modal {
  .details-item {
    &:not(:last-child) {
      margin-bottom: 16px;
    }
    .title {
      font-size: 12px;
      color: #cecfd4;
      line-height: 17px;
      margin-bottom: 4px;
    }
    .content {
      font-size: 16px;
      color: #333333;
      line-height: 22px;
      margin-bottom: 0;
    }
  }
}
</style>
